<template>
    <div class="component-wrap">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0 px-3': $vuetify.breakpoint.xs, 'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <companyProfileControl :company_page="company_page"
                                       class="border-bottom" :status_access="user_role.managment_of_organizations.includes('C')"
                />
                <v-layout align-center class="mt-4">
                    <div v-if="company_page.image" style="width: 100px;">
                        <img :src="company_page.image | avatar" alt="company">
                    </div>
                    <h1 class="display-1 ml-4">{{ company_page.name }}</h1>
                </v-layout>
                <v-flex class="mb-4">

                    <companyProfileInfo :company_page="company_page" />

                </v-flex>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu            from '@/components/blocks/common/Header_menu.vue';
import UserMenu              from '@/components/blocks/common/User_menu.vue';
import FooterBlock           from '@/components/blocks/common/Footer.vue';
import companyProfileInfo    from '@/components/view_blocks/Company_profile/Company_profile_info/Company_profile_info';
import companyProfileControl from '@/components/view_blocks/Company_profile/Company_profile_control';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    companyProfileInfo,
    companyProfileControl,
  },
  props: {
    company_page: {
      type: Object,
    },
  },
  data() {
    return {
      user_role: {
        managment_of_organizations: [],
      },
    };
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('company_profile', [
      'other_company',
    ]),
    ...mapGetters('company_profile/info', [
      'active_status',
      'company_image',
      'company_info',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('company_profile/statuses', [
      'user_status',
      'status_confirmed',
      'status_off',
      'status_processing',
      'status_declined',
    ]),
    company_status: function() {
      return this.active_status;
    },
  },
  async mounted() {
    await this.get_load_user();
    if (localStorage.user != 'undefined') {
      this.$set(this.user_role, 'managment_of_organizations', this.user.role.managment_of_organizations.rights);
    }
  },
  methods: {
    ...mapActions('autorisation', [
      'get_load_user',
    ]),
  },
};
</script>

